import autofollowStatus1x from '../images/modules/autofollow-status.png';
import autofollowStatus2x from '../images/modules/autofollow-status@2x.png';
import autofollowStatus3x from '../images/modules/autofollow-status@3x.png';
import autolikeStatus1x from '../images/modules/autolike-status.png';
import autolikeStatus2x from '../images/modules/autolike-status@2x.png';
import autolikeStatus3x from '../images/modules/autolike-status@3x.png';
import clerkStatus1x from '../images/modules/clerk-status.png';
import clerkStatus2x from '../images/modules/clerk-status@2x.png';
import clerkStatus3x from '../images/modules/clerk-status@3x.png';
import congratsStatus1x from '../images/modules/congrats-status.png';
import congratsStatus2x from '../images/modules/congrats-status@2x.png';
import congratsStatus3x from '../images/modules/congrats-status@3x.png';
import autofollow1x from '../images/modules/video/cover-autofollow.png';
import autofollow2x from '../images/modules/video/cover-autofollow@2x.png';
import autofollow3x from '../images/modules/video/cover-autofollow@3x.png';
import autolike1x from '../images/modules/video/cover-autolike.png';
import autolike2x from '../images/modules/video/cover-autolike@2x.png';
import autolike3x from '../images/modules/video/cover-autolike@3x.png';
import clerk1x from '../images/modules/video/cover-clerk.png';
import clerk2x from '../images/modules/video/cover-clerk@2x.png';
import clerk3x from '../images/modules/video/cover-clerk@3x.png';
import congrats1x from '../images/modules/video/cover-congrats.png';
import congrats2x from '../images/modules/video/cover-congrats@2x.png';
import congrats3x from '../images/modules/video/cover-congrats@3x.png';
import video from '../images/video.mp4';
import cases from './cases';
import reviewAvatars from './review-avatars';

export const modList = {
  congrats: {
    num: 1,
    iconType: 'giftFilled',
    title: 'Поздравления',
    description:
      'Попробуйте прямо сейчас. Сервису не нужен Ваши пароль для работы, что делает его самым безопасным.',
    statusScreenshot: `${clerkStatus1x} 1x, ${clerkStatus2x} 2x, ${clerkStatus3x} 3x`,
  },
  autolike: {
    num: 2,
    iconType: 'likeFilled',
    title: 'Привлечение внимания',
    description:
      'Попробуйте прямо сейчас. Сервису не нужен Ваши пароль для работы, что делает его самым безопасным.',
    statusScreenshot: `${autolikeStatus1x} 1x, ${autolikeStatus2x} 2x, ${autolikeStatus3x} 3x`,
  },
  clerk: {
    num: 3,
    iconType: 'commentIndicatorFilled',
    title: 'Секретарь',
    description:
      'Попробуйте прямо сейчас. Сервису не нужен Ваши пароль для работы, что делает его самым безопасным.',
    statusScreenshot: `${congratsStatus1x} 1x, ${congratsStatus2x} 2x, ${congratsStatus3x} 3x`,
  },
  autofollow: {
    num: 4,
    iconType: 'userAddedFilled',
    title: 'Автоподписка',
    description:
      'Попробуйте прямо сейчас. Сервису не нужен Ваши пароль для работы, что делает его самым безопасным.',
    statusScreenshot: `${autofollowStatus1x} 1x, ${autofollowStatus2x} 2x, ${autofollowStatus3x} 3x`,
  },
};

export const videoList = {
  about: {
    title: 'О сервисе за 4 минуты',
    video: 'asiPggs31L4',
    cover: null,
  },
  how: { title: 'Видео обзор', video: 'asiPggs31L4', cover: null },
  autolike: {
    video: 'mpplnApjMXQ',
    cover: `<img srcSet="${autolike1x} 1x, ${autolike2x} 2x, ${autolike3x} 3x"  alt="" title="${modList.autolike.title}"/>`,
  },
  congrats: {
    video: 'bshq-jeWw2U',
    cover: `<img srcSet="${congrats1x} 1x, ${congrats2x} 2x, ${congrats3x} 3x"  alt="" title="${modList.congrats.title}"/>`,
  },
  clerk: {
    video: '5T0PC3asBk8',
    cover: `<img srcSet="${clerk1x} 1x, ${clerk2x} 2x, ${clerk3x} 3x"  alt="" title="${modList.clerk.title}"/>`,
  },
  autofollow: {
    video: 'iY7dzsGyDOY',
    cover: `<img srcSet="${autofollow1x} 1x, ${autofollow2x} 2x, ${autofollow3x} 3x"  alt="" title="${modList.autofollow.title}"/>`,
  },
};

export { cases, reviewAvatars };
